import { ServiceType } from "~/utils/constants";
import { TClient } from "./client";
import { TUser } from "./user";
import { InventoryTemplate } from "~/services/inventory-templates/inventory-templates.types";
import { TVesselType } from "~/services/vessel/vessel.types";

// Shipping Address type (from client.shippingAddresses)
export interface ShippingAddress {
  id: string;
  addressName?: string;
  address: string;
  anotherAddress?: string;
  apt?: string;
  city: string;
  state: string;
  zip: string;
  country?: string;
  type?: string;
  travelTime?: number;
  specialInstructions?: string;
  clientId?: string;
}

export enum EstimateStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  CONVERTED = 'CONVERTED',
}

export interface TempClientData {
  name: string;
  email?: string;
  phone?: string;
}

export interface TempLocationData {
  name?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface EstimateService {
  id: string;
  estimateTicketId: string;
  serviceType: ServiceType;
  serviceDate?: Date | string;
  duration?: number;
  staffCount?: number;
  vesselTypeId?: string;
  vesselType?: TVesselType;
  vesselId?: string;
  vessel?: { id: string; name: string; hourlyRate?: number };
  locationId?: string;
  location?: ShippingAddress;
  tempLocationData?: TempLocationData;
  inventoryTemplates?: InventoryTemplate[];
  estimatedPrice?: number;
  notes?: string;
  estimatedItemCount?: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface EstimateTicket {
  id: string;
  referenceNumber: string;
  clientId?: string;
  client?: TClient;
  tempClientData?: TempClientData;
  estimateDate: Date | string;
  status: EstimateStatus;
  createdById: string;
  createdBy?: TUser;
  services: EstimateService[];
  estimatedTotal?: number;
  notes?: string;
  convertedToJobTicketId?: string;
  createdAt: Date;
  updatedAt: Date;
}

// DTOs for API
export interface CreateEstimateServiceDto {
  estimateTicketId: string;
  serviceType: ServiceType;
  serviceDate?: string;
  duration?: number;
  staffCount?: number;
  vesselTypeId?: string;
  vesselId?: string;
  locationId?: string;
  tempLocationData?: TempLocationData;
  inventoryTemplateIds?: string[];
  estimatedPrice?: number;
  notes?: string;
  estimatedItemCount?: number;
}

export interface CreateEstimateDto {
  clientId?: string;
  tempClientData?: TempClientData;
  estimateDate?: string;
  notes?: string;
  services?: CreateEstimateServiceDto[];
}

export interface UpdateEstimateDto {
  clientId?: string;
  tempClientData?: TempClientData;
  estimateDate?: string;
  notes?: string;
  status?: EstimateStatus;
  services?: CreateEstimateServiceDto[];
}

export interface GetEstimatesParams {
  page?: number;
  pageSize?: number;
  status?: EstimateStatus;
  clientId?: string;
  search?: string;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export interface ConvertEstimateDto {
  estimateId: string;
  clientId?: string;
  projectId?: string;
}
